import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polyline,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "16", y2: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "5,9 12,2 19,9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "21", r: "1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowUpFromDot";
const ArrowUpFromDot = memo(themed(Icon));
export {
  ArrowUpFromDot
};
//# sourceMappingURL=arrow-up-from-dot.js.map
